<div *transloco="let t">
  <h1 class="mb-0">
    {{ t('authentication.new_password') }}
  </h1>
  <p>{{ t('authentication.make_new_password') }}</p>
  <div class="registration-form mt-4">
    @if (showSuccessAlert || showWarningAlert) {
      <div class="reset-info">
        @if (showSuccessAlert) {
          <alert
            [type]="'success'"
            [dismissible]="true"
            (onClosed)="hideAlerts()"
            >
            <div class="align-middle" *transloco="let t">
              <strong class="ml-1">{{t('common.success')}}</strong>
              <span>{{t('authentication.password_reset_success')}}</span>
              <button class="btn btn-primary m-2" [routerLink]="'/login'">{{t('common.log_in')}}</button>
            </div>
          </alert>
        }
        @if (showWarningAlert) {
          <alert
            [type]="'warning'"
            [dismissible]="true"
            (onClosed)="hideAlerts()"
            >
            <strong>{{ t(errorMessage || 'error.something_went_wrong') }}</strong>
          </alert>
        }
      </div>
    }
    @if (!showSuccessAlert) {
      <div>
        <form [formGroup]="PasswordResetForm" role="form" *transloco="let t">
          <!-- Password* -->
          <div class="input-self">
            <label for="password" class="form-label">
              {{ t('authentication.password') }}<span class="required-sign">*</span>
            </label>
            <div
              class="input-group mb-3"
              [ngClass]="{ 'ng-invalid': showPasswordError, 'ng-valid': isPasswordValid }"
              >
              <span class="input-group-text text-primary-light">
                <i class="fa fa-unlock-alt" aria-hidden="true"></i>
              </span>
              <input
                class="form-control input-lg"
                type="password"
                id="password"
                formControlName="password"
                />
              @if (showPasswordError) {
                <div class="invalid-feedback">
                  {{ t(passwordErrorKey) }}
                </div>
              }
            </div>
          </div>
          <!-- Repeat password* -->
          <div class="input-self">
            <label for="repeatPassword" class="form-label">
              {{ t('authentication.password_again') }}<span class="required-sign">*</span>
            </label>
            <div
              class="input-group mb-3"
              [ngClass]="{ 'ng-invalid': showRepeatPasswordError, 'ng-valid': isRepeatPasswordValid }"
              >
              <span class="input-group-text text-primary-light">
                <i class="fa fa-unlock-alt" aria-hidden="true"></i>
              </span>
              <input
                class="form-control input-lg"
                type="password"
                id="repeatPassword"
                formControlName="repeatPassword"
                />
              @if (showRepeatPasswordError) {
                <div class="invalid-feedback">
                  {{ t(repeatPasswordErrorKey) }}
                </div>
              }
            </div>
          </div>
          <!-- Submit | Button -->
          <div class="input-self">
            <div class="input-group my-3">
              @if (!loading) {
                <button
                  class="btn btn-lg btn-primary w-100"
                  [disabled]="!canSubmit"
                  (click)="sendRequest()"
                  >
                  {{ t('common.confirm') }}
                </button>
              }
              @if (loading) {
                <multisite-loader-globe-animation-detail
                  [width]="100"
                  [height]="100"
                  >
                </multisite-loader-globe-animation-detail>
              }
            </div>
          </div>
        </form>
      </div>
    }
  </div>
</div>
